import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';

import { Home1Component } from './pages/home/home1/home1.component';
// import { Home2Component } from './pages/home/home2/home2.component';
// import { Home3Component } from './pages/home/home3/home3.component';
// import { Home4Component } from './pages/home/home4/home4.component';
// import { Home5Component } from './pages/home/home5/home5.component';
import { About1Component } from './pages/about/about1/about1.component';
import { About2Component } from './pages/about/about2/about2.component';
// import { ServicesComponent } from './pages/services/services/services.component';
import { ServiceDetailsComponent } from './elements/school-mental-health/service-details/service-details.component';
import { OurTeamComponent } from './pages/team/our-team/our-team.component';
import { WelcomeSoulSpaceComponent } from './elements/about_section/welcome-soul-space/welcome-soul-space.component';
import { OurMissionComponent } from './elements/about_section/our-mission/our-mission.component';
import { WhoAreWeComponent } from './elements/about_section/who-r-v/who-r-v.component';
import { WhyChooseSoulSpaceComponent } from './elements/about_section/why-choose-ss/why-choose-ss.component';
import { MentalWellbeingComponent } from './elements/about_section/mental-wellbeing/mental-wellbeing.component';
import { OurServicesComponent } from './pages/project/ourservices/ourservices.component';
import { Project2Component } from './pages/project/project2/project2.component';
import { ProjectCarouselComponent } from './pages/project/project-carousel/project-carousel.component';
import { ProjectSingleComponent } from './pages/project/project-single/project-single.component';
import { BlogGridComponent } from './pages/blog/blog-grid/blog-grid.component';
import { BlogSingleComponent } from './pages/blog/blog-single/blog-single.component';
import { BlogListComponent } from './pages/blog/blog-list/blog-list.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import {FaqsComponent} from './elements/faq/faqs/faqs.component';
import {OurJourneyComponent} from'./elements/about_section/our-journey/our-journey.component';
import { SmOurMissionComponent } from './elements/school-mental-health/sm-our-mission/sm-our-mission.component';
import { SmOurVisionComponent } from './elements/school-mental-health/sm-our-vision/sm-our-vision.component';
import { SmOurImpactComponent } from './elements/school-mental-health/sm-our-impact/sm-our-impact.component';
import { OurUniqueApproachComponent } from './elements/school-mental-health/our-unique-approach/our-unique-approach.component';
import { ProgramOverviewComponent } from './elements/school-mental-health/program-overview/program-overview.component';
import { PsychoTherapyComponent } from './pages/project/psycho-therapy/psycho-therapy.component';
import { AnxietyComponent } from './pages/project/anxiety/anxiety.component';
import { DepressionTreatmentComponent } from './pages/project/depression-treatment/depression-treatment.component';
import { AngerManagementComponent } from './pages/project/anger-management/anger-management.component';
import { OcdComponent } from './pages/project/ocd/ocd.component';
import { PtsdComponent } from './pages/project/ptsd/ptsd.component';
import { IndustrialOrganizationalComponent } from './pages/project/industrial-organizational/industrial-organizational.component';
import { CareerCounselingComponent } from './pages/project/career-counseling/career-counseling.component';
import { ChildPsychologyComponent } from './pages/project/child-psychology/child-psychology.component';
import { DyslexiaComponent } from './pages/project/dyslexia/dyslexia.component';
import { SpecialEducationComponent } from './pages/project/special-education/special-education.component';
import { MoodDisordersComponent } from './pages/project/mood-disorders/mood-disorders.component';
import { EffectiveEmotionalComponent } from './pages/project/effective-emotional/effective-emotional.component';
import { BehaviorsThoughtComponent } from './pages/project/behaviors-thought/behaviors-thought.component';
import { OtherServicesComponent } from './pages/project/other-services/other-services.component';
import { CorporateWellnessComponent } from './pages/project/corporate-wellness/corporate-wellness.component';
import { StressManagementComponent } from './pages/project/stress-management/stress-management.component';
import { InnovativeServicesComponent } from './pages/project/innovative-services/innovative-services.component';
import { SchoolProgramComponent } from './elements/our-programs/school-mental-program/school-mental-program.component';
import { WomenwellnessComponent } from './elements/our-programs/women-wellness-program/women-wellness-program.component';
import { ElderlyWellnessComponent } from './elements/our-programs/elderly-wellness-program/elderly-wellness-program.component';
import { OurProgramsSingle } from './elements/our-programs/our-programs-single/our-programs-singlecomponent';
import { BookAppointment } from './elements/book-appointment/book-appointment.component';
import { BlogSingle1Component } from './pages/blog/blog-single1/blog-single1.component';
import { BlogSingle2Component } from './pages/blog/blog-single2/blog-single2.component';
import { BlogSingle3Component } from './pages/blog/blog-single3/blog-single3.component';
import { BlogSingle4Component } from './pages/blog/blog-single4/blog-single4.component';
import { Team1Component } from './elements/team_section/team1/team1.component';
import { ApplicantRegistrationComponent } from './pages/applicant-registration/applicant-registration.component';
import { AppointmentComponent } from './pages/appointment/appointment.component';
import { SigleAboutUSPage } from './elements/about_section/aboutsinglepage/about-single-page.component';


const routes: Routes = [
  { path: '', component: Home1Component },
  { path: 'index', component: Home1Component },
  // { path: 'index2', component: Home2Component },
  // { path: 'index3', component: Home3Component },
  // { path: 'index4', component: Home4Component },
  { path: 'faqs', component: FaqsComponent },
  {path:'anxiety',component:AnxietyComponent},
  {path:'depression-treatment',component:DepressionTreatmentComponent},
  {path:'anger-management',component:AngerManagementComponent},
  {path:'ocd',component:OcdComponent},
  {path:'ptsd',component:PtsdComponent},
  {path:'industrial-organizational',component:IndustrialOrganizationalComponent},
  {path:'career-counseling',component:CareerCounselingComponent},
  {path:'child-psychology',component:ChildPsychologyComponent},
  {path:'dyslexia',component:DyslexiaComponent},
  {path:'special-education',component:SpecialEducationComponent},
  {path:'mood-disorders',component:MoodDisordersComponent},
  {path:'effective-emotional',component: EffectiveEmotionalComponent},
  {path:'behaviors-thought',component: BehaviorsThoughtComponent},
  {path:'other-services',component: OtherServicesComponent},
  {path:'corporate-wellness',component:CorporateWellnessComponent},
  {path:'stress-management',component:StressManagementComponent},
  {path:'innovative-services',component: InnovativeServicesComponent},
  {path:'sm-our-mission',component:SmOurMissionComponent},
  {path:'sm-our-vision',component:SmOurVisionComponent},
  {path:'our-impact',component:SmOurImpactComponent},
  {path:'unique-approach',component:OurUniqueApproachComponent},
  {path:'programe-over-view',component:ProgramOverviewComponent},
  { path:'our-journey',component:OurJourneyComponent},
  { path: 'about1', component: About1Component },
  { path: 'about2', component: About2Component },
  { path: 'psycho-therapy', component: PsychoTherapyComponent},
  { path: 'service-detail', component: ServiceDetailsComponent },
  { path: 'our-team', component: OurTeamComponent },
  { path: 'welcome-soul-space', component: WelcomeSoulSpaceComponent },
  { path: 'our-mission', component: OurMissionComponent },
  { path: 'who-r-v', component: WhoAreWeComponent },
  { path: 'why-choose-ss', component: WhyChooseSoulSpaceComponent },
  { path: 'mental-wellbeing', component: MentalWellbeingComponent },
  { path: 'our-services', component: OurServicesComponent },
  // {path:}
  { path: 'project2', component: Project2Component },
  { path: 'project-carousel', component: ProjectCarouselComponent },
  { path: 'project-single', component: ProjectSingleComponent },
  { path: 'blog-grid', component: BlogGridComponent },
  { path: 'blog-list', component: BlogListComponent },
  { path: 'priority-schools', component: BlogSingleComponent },
  { path: 'school-program', component: SchoolProgramComponent},
  { path: 'women-wellness', component: WomenwellnessComponent },
  { path: 'elderly-wellness', component: ElderlyWellnessComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'book-appointment', component: BookAppointment },
  { path: 'issues-children', component: BlogSingle1Component },
  { path: 'anxiety-school', component: BlogSingle2Component },
  { path: 'techniques-work', component: BlogSingle3Component },
  { path: 'selping-students', component: BlogSingle4Component },
  { path: 'team-our', component: Team1Component },
  {path:'registration',component:ApplicantRegistrationComponent},
  {path:'appointment',component:AppointmentComponent},
  { path: 'about-single-page', component: SigleAboutUSPage },
  { path: 'our-program-single', component: OurProgramsSingle },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }]
})


export class AppRoutingModule { }
